import React, { useContext } from 'react';
import { I18nContext } from 'react-i18next';
import { WithTranslationProps } from './Components/Translation/WithTranslationProps';

function withTranslation<T>(
  Component: React.ComponentType<T & WithTranslationProps>,
) {
  return (props: Omit<T, keyof WithTranslationProps>) => {
    const context = useContext(I18nContext);

    if (!context) {
      throw new Error('withTranslation must be used within an I18nProvider');
    }

    const { i18n } = context;
    const tReady = i18n.isInitialized;

    const translationProps: WithTranslationProps = {
      t: i18n.t.bind(i18n), // Enlazar correctamente `t` desde i18n
      i18n,
      tReady,
    };

    return <Component {...(props as T)} {...translationProps} />;
  };
}

export default withTranslation;
